import {
  ACTIVITIES_COMPONENT_TYPE_IMAGE,
  ACTIVITIES_COMPONENT_TYPE_IMAGE_SPHERE,
  ACTIVITIES_COMPONENT_TYPE_INFO_BOX,
  ACTIVITIES_COMPONENT_TYPE_VIDEO,
  ACTIVITIES_COMPONENT_TYPE_EBOOK,
  ACTIVITIES_COMPONENT_TYPE_DOCUMENT,
  ACTIVITIES_COMPONENT_TYPE_AUDIO,
  ACTIVITIES_COMPONENT_TYPE_EBOOK_INTERACTIVE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE,
  ACTIVITIES_COMPONENT_TYPE_LINK,
  ACTIVITIES_COMPONENT_TYPE_WEBTOOL,
  ACTIVITIES_COMPONENT_TYPE_GUIDED_RESEARCH,
  ACTIVITIES_COMPONENT_TYPE_SLIDESHOW,
  ACTIVITIES_COMPONENT_TYPE_VOCABULARY,
  ACTIVITIES_COMPONENT_TYPE_RIVE_ANIMATION,
  ACTIVITIES_COMPONENT_TYPE_GIF,
} from 'global/constants';
import {
  ComponentAudio,
  ComponentDocument,
  ComponentEbook,
  ComponentEbookInteractive,
  ComponentGuidedResearch,
  ComponentImage,
  ComponentImageSphere,
  ComponentInfoBox,
  ComponentInteractive,
  ComponentLink,
  ComponentSlideshow,
  ComponentVideo,
  ComponentVocabulary,
  ComponentRiveAnimation,
  ComponentGif,
} from 'approot/activity-builder/components/component.constants';
import EbookPrint from 'approot/activity-builder/components/ebook/ebook-print';
import DocumentPrint from 'approot/activity-builder/components/document/document-print';
import SlideshowPrint from 'approot/activity-builder/components/slideshow/slideshow-print';
import VideoPrint from 'approot/activity-builder/components/video/video-print';
import ImagePrint from 'approot/activity-builder/components/image/image-print';
import ImageSpherePrint from 'approot/activity-builder/components/image-sphere/image-sphere-print';
import InteractivePrint from 'approot/activity-builder/components/interactive/interactive-print';
import InteractiveEbookPrint from 'approot/activity-builder/components/interactive-ebook/interactive-ebook-print';
import LinkPrint from 'approot/activity-builder/components/link/link-print';
import WebToolPrint from 'approot/activity-builder/components/webtool/webtool-print';
import GuidedResearchPrint from 'approot/activity-builder/components/guided-research/guided-research-print';
import VocabularyPrint from 'approot/activity-builder/components/vocabulary/vocabulary-print';
import InfoBoxPrint from 'approot/activity-builder/components/info-box/info-box-print';
import RivePrint from 'approot/activity-builder/components/rive/rive-print';
import GifPrint from 'approot/activity-builder/components/gif/gif-print';
import type { InteractiveLessonSectionComponentFragment } from '../lesson-builder.graphql.generated';

type Props = {
  component: InteractiveLessonSectionComponentFragment;
  isPrintPreview?: boolean;
  contentVersion: string | null | undefined;
};

const ComponentsPrintLayout = ({
  component,
  isPrintPreview,
  contentVersion,
}: Props) => {
  return (
    <>
      {component.type === ACTIVITIES_COMPONENT_TYPE_INFO_BOX && (
        <InfoBoxPrint {...(component as ComponentInfoBox)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_SLIDESHOW && (
        <SlideshowPrint {...(component as ComponentSlideshow)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_EBOOK && (
        <EbookPrint
          {...(component as ComponentEbook)}
          isPrintPreview={isPrintPreview || false}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_DOCUMENT && (
        <DocumentPrint
          {...(component as ComponentDocument)}
          isPrintPreview={isPrintPreview || false}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_VIDEO && (
        <VideoPrint
          {...(component as ComponentVideo)}
          isPrintPreview={isPrintPreview || false}
          contentVersion={contentVersion}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_AUDIO && (
        <VideoPrint
          {...(component as ComponentAudio)}
          isPrintPreview={isPrintPreview || false}
          contentVersion={contentVersion}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_IMAGE && (
        <ImagePrint {...(component as ComponentImage)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_IMAGE_SPHERE && (
        <ImageSpherePrint {...(component as ComponentImageSphere)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_INTERACTIVE && (
        <InteractivePrint
          {...(component as ComponentInteractive)}
          isPrintPreview={isPrintPreview || false}
          contentVersion={contentVersion}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_EBOOK_INTERACTIVE && (
        <InteractiveEbookPrint
          {...(component as ComponentEbookInteractive)}
          isPrintPreview={isPrintPreview || false}
          contentVersion={contentVersion}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_LINK && (
        <LinkPrint
          {...(component as ComponentLink)}
          isPrintPreview={isPrintPreview || false}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_WEBTOOL && (
        <WebToolPrint
          {...(component as ComponentLink)}
          isPrintPreview={isPrintPreview || false}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_GUIDED_RESEARCH && (
        <GuidedResearchPrint
          {...(component as ComponentGuidedResearch)}
          isPrintPreview={isPrintPreview || false}
          contentVersion={contentVersion}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_VOCABULARY && (
        <VocabularyPrint {...(component as ComponentVocabulary)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_RIVE_ANIMATION && (
        <RivePrint {...(component as ComponentRiveAnimation)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_GIF && (
        <GifPrint {...(component as ComponentGif)} />
      )}
    </>
  );
};

export default ComponentsPrintLayout;
